import React from 'react';
import { borderRadius, height, styled } from '@mui/system';
import { useTheme } from '@mui/styles';
import { Tooltip } from '@mui/material';

import { appInsights } from '../../../auth/appInsight';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

const IconBackGround = styled('div')(
  ({ theme, width, height, backgroundcolor, padding, borderradius, backgroundhovercolor, cursor, bordercolor, disabled, responsiveheight, responsivewidth, xllheight, xllwidth, responsiveborderrad, justifycontent }) => ({
    background: backgroundcolor || theme.palette.background.default,
    borderRadius: borderradius || '10px',
    padding: padding || '4px',
    width: width || '28px',
    display: 'flex',
    justifyContent: justifycontent || 'center',
    alignItems: 'center',
    height: height || '28px',
    cursor: disabled ? '' : 'pointer',
    border: bordercolor ? `2px solid ${bordercolor} !important` : `2px solid ${theme.palette.border.border} !important`,
    [theme.breakpoints.down('sm')]: {
      height: responsiveheight || '24px',
      width: responsivewidth || '24px',
      borderRadius: responsiveborderrad || '6px'
    },
    [theme.breakpoints.up('xll')]: {
      borderRadius: getStringProduct(1.25, borderradius || '10px'),
      padding: getStringProduct(1.25, padding || '4px'),
      width: getStringProduct(1.25, width || '28px'),
      height: getStringProduct(1.25, height || '28px'),
      border: getStringProduct(1.25, `2px solid ${bordercolor || theme.palette.border.border}`) + '!important'
    },
    [theme.breakpoints.up('xlll')]: {
      borderRadius: getStringProduct(1.66, borderradius || '10px'),
      padding: getStringProduct(1.66, padding || '4px'),
      width: getStringProduct(1.66, width || '28px'),
      height: getStringProduct(1.66, height || '28px'),
      border: getStringProduct(1.66, `2px solid ${bordercolor || theme.palette.border.border}`) + '!important'
    },
    [theme.breakpoints.up('xl4')]: {
      borderRadius: getStringProduct(2.46, borderradius || '10px'),
      padding: getStringProduct(2.46, padding || '4px'),
      width: getStringProduct(2.46, width || '28px'),
      height: getStringProduct(2.46, height || '28px'),
      border: getStringProduct(2.46, `2px solid ${bordercolor || theme.palette.border.border}`) + '!important'
    }
  })
);
const IconImg = styled('img')(({ theme, imgColor, imageheight, imagewidth, iconbottommargin, margintop, marginleft }) => {
  const applyScaling = (value, scale) => (value ? `${getStringProduct(scale, value)}` : '');

  return {
    height: imageheight,
    width: imagewidth,
    marginBottom: iconbottommargin || undefined,
    marginTop: margintop || undefined,
    marginLeft: marginleft || undefined,
    fill: imgColor || theme.palette.primary.main,
    [theme.breakpoints.up('xll')]: {
      width: getStringProduct(1.25, imagewidth),
      height: getStringProduct(1.25, imageheight),
      marginBottom: applyScaling(iconbottommargin, 1.25),
      marginTop: applyScaling(margintop, 1.25),
      marginLeft: applyScaling(marginleft, 1.25)
    },
    [theme.breakpoints.up('xlll')]: {
      width: getStringProduct(1.66, imagewidth),
      height: getStringProduct(1.66, imageheight),
      marginBottom: applyScaling(iconbottommargin, 1.66),
      marginTop: applyScaling(margintop, 1.66),
      marginLeft: applyScaling(marginleft, 1.66)
    },
    [theme.breakpoints.up('xl4')]: {
      width: getStringProduct(2.46, imagewidth),
      height: getStringProduct(2.46, imageheight),
      marginBottom: applyScaling(iconbottommargin, 2.46),
      marginTop: applyScaling(margintop, 2.46),
      marginLeft: applyScaling(marginleft, 2.46)
    }
  };
});

const FreedomFollowUpIcon = (props) => {
  const theme = useTheme();

  const { iconimg, imageheight, imagewidth, padding, backgroundhovercolor, iconbottommargin, marginleft, bordercolor, borderradius, margintop, tooltiptitle, justifycontent, backgroundcolor } = props;
  try {
    return (
      <Tooltip arrow enterTouchDelay={0} title={tooltiptitle ? tooltiptitle : ''} placement="top-start">
        <IconBackGround
          borderradius={borderradius}
          bordercolor={bordercolor}
          backgroundcolor={backgroundcolor}
          backgroundhovercolor={backgroundhovercolor || theme.palette.hoverColor.cardHover}
          justifycontent={justifycontent}
          padding={padding}
          theme={theme}
          {...props}
        >
          <IconImg iconbottommargin={iconbottommargin} margintop={margintop} marginleft={marginleft} src={iconimg} imageheight={imageheight} imagewidth={imagewidth} />
        </IconBackGround>
      </Tooltip>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomFollowUpIcon;
